import React from "react";
import { Route, Routes } from "react-router-dom";

import Terms from "@/components/screens/Terms";
import TERMS_OF_USE_MESSAGES from "@/messages/terms/terms.messages";

const TermsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Terms messages={TERMS_OF_USE_MESSAGES} />} />
      <Route path="/" element={<Terms messages={TERMS_OF_USE_MESSAGES} />} />
    </Routes>
  );
};

export default TermsPage;
